export default __webpack_public_path__ + "static/media/brawl-stars@2x.b551724f.webp";